<template>
    <div class="main">
        <c-panel>

            <el-form label-position="top" class="u-mb-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24" v-if="[4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo))">
                        <el-form-item key="instituicao">
                            <el-select @change="loadingTurmas" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição">
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row> 
                <el-row :gutter="10">                    
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-form-item key="instituicao">
                            <el-select @change="getStatus" v-model="filtro.turma_id" filterable placeholder="Turma">
                                <el-option-group
                                    v-for="(grupo, i) in turmas"
                                    :key="i"
                                    label="">
                                <el-option
                                    v-for="turma in grupo"
                                    :key="turma.id"
                                    :label="`${turma.curso.nome} ${turma.nome}`"
                                    :value="turma.id">
                                </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item key="tipo">
                            <el-select @change="getStatus" v-model="filtro.tipo">
                                <el-option label="FREQUENCIA" value="f"></el-option>
                                <el-option label="CONTEÚDO" value="c"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>               
            </el-form>
            
            <div v-if="loadingStatus" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <div v-if="Object.keys(status).length !== 0 && !loadingStatus">

                <table class="table table-striped table-status">
                    <thead>
                        <tr>
                            <th class="u-text-center"></th>
                            <th 
                                :colspan="item" 
                                class="u-text-center"
                                v-for="(item, i) in status['qtd_max_horario']"
                                :key="i+Math.random()"
                            >
                                {{ $CONSTANTS.NOME_MES(i) }}
                            </th>
                        </tr>
                    </thead>
                    <thead>                    
                        <tr>
                            <td class="u-text-center">DIA</td>
                            <template v-for="item in status['qtd_max_horario']">
                                <td 
                                    class="u-text-center"
                                    v-for="(qtd, j) in item"
                                    :key="j+Math.random()"
                                >
                                    {{ item > 1 ? (j+1)+'º' : 'Frequência' }}
                                </td>
                            </template>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="(dia, id) in status['status']" :key="id+Math.random()">

                            <td class="u-text-center">{{ id }}</td>
                            <template v-for="(mes, ii) in dia">
                                <template v-if="mes.length > 0">
                                   
                                    <td v-for="(horario, ih) in mes" :key="(id+'1'+ih+Math.random())" :class="{ pendente: !horario, concluido: horario }" class="u-text-center"></td>
                                    <td title="Dia não computado" v-for="(qtd, ic) in (status['qtd_max_horario'][ii] - mes.length)" :key="(id+'2'+ic+Math.random())" class="u-text-center">
                                        -
                                    </td>
                                </template>
                                <template v-else>
                                    <td v-for="(qtd, ie) in status['qtd_max_horario'][ii]" :key="(id+'3'+ie+Math.random())" class="u-text-center">
                                        -
                                    </td>
                                </template>
                            </template>

                        </tr>
                        
                    </tbody>
                </table>
                


            </div>
            <div v-if="Object.keys(status).length === 0 && !loadingStatus">
                Selecione as opções de filtros.
            </div>
            
        </c-panel>
    </div>
</template>
<script>

export default {
    data: () => ({
        filtro: {
            instituicao_id: '',
            turma_id: '',
            tipo: ''
        },
        turmas: [],
        status: {},
        loadingStatus: false
    }),
    mounted () { 
        this.loadingTurmas();
    },
    methods: {
        loadingTurmas() {

            this.filtro.turma_id = '';

            if(!this.filtro.instituicao_id && this.$store.state.config.instituicao){
                this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
            }

            if(!this.filtro.instituicao_id) {
                return;
            }            

            let p = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${p}`, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;                

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        getStatus(){

            if(!this.filtro.instituicao_id || !this.filtro.turma_id || !this.filtro.tipo) {
                return;
            }  
            
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/getDiarioStatusForConferencia`, this.filtro, this.$store.getters.getHeaderAuth).then(response => {
                

                if(typeof response.data.error !== 'undefined'){

                    window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});

                }else{

                    this.status = response.data;
                    this.loadingStatus = false;    
                   
                }

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
    },
    components:{  }
}
</script>
<style>
    .table-status td, .table-status th {
        border: 1px solid #ccc !important;
        padding: 1px;
    }
    .pendente {
        background-color: #efff00;
    }
    .concluido {
        background-color: #3aaf38;
    }
</style>